import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterInfo>
            <FooterLogo>Bartłomiej Zawadzki</FooterLogo>
            <FooterText>
              {t('footer.madeBy')}
            </FooterText>
          </FooterInfo>
          
          <SocialLinks>
            <SocialLink href="https://github.com/BartekZawadzki" target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </SocialLink>
            <SocialLink href="https://www.linkedin.com/in/bartekzawadzki/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </SocialLink>
            <SocialLink href="mailto:zawadzkib333@gmail.com">
              <FaEnvelope />
            </SocialLink>
          </SocialLinks>
        </FooterContent>
        
        <FooterBottom>
          <Copyright>
            &copy; {currentYear} Bartłomiej Zawadzki. {t('footer.rights')}
          </Copyright>
        </FooterBottom>
      </div>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: var(--background-color);
  color: var(--text-color);
  padding: 3rem 0 1.5rem;
  border-top: 1px solid var(--gray-200);
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const FooterInfo = styled.div`
  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
`;

const FooterLogo = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(to right, var(--primary-color), var(--accent-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const FooterText = styled.p`
  color: var(--gray-400);
  margin-bottom: 0;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--gray-100);
  color: var(--text-color);
  font-size: 1.25rem;
  transition: all var(--transition-fast) ease;
  
  &:hover {
    background-color: var(--primary-color);
    transform: translateY(-3px);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid var(--gray-200);
  padding-top: 1.5rem;
  text-align: center;
`;

const Copyright = styled.p`
  color: var(--gray-500);
  font-size: 0.875rem;
  margin: 0;
`;

export default Footer;